import React from "react";
import { NavLink, Link } from "react-router-dom";
import "./style.scss";
import useHeader from "~components/Header/hooks/useHeader";
import { SearchAdd } from "~misc/icons";
import { initialPath } from "~misc/paths";
const CreditInfoMenu = ({ id, editSender = false }) => {
  const { path } = useHeader();

  return (
    <div className="bg-white pt-8 pb-10 md:px-8 container rounded-b-2xl mb-20 border-terciaria border-t-0 border relative CreditMenu h-[109px]">
      <div className="flex justify-center container flex-col md:flex-row gap-y-4">
        {!editSender && (
          <NavLink
            to={`${initialPath}/carteira/emissor/${id}`}
            className="text-[#9DA2B6] font-bold text-xl flex-grow flex-shrink text-center py-2 px-8 max-w-[420px] menu"
          >
            Código Emissor
          </NavLink>
        )}
        <NavLink
          to={`${initialPath}/carteira/recebedor/${id}`}
          className={`text-[#9DA2B6] font-bold text-xl flex-grow flex-shrink text-center py-2 px-8 max-w-[420px] menu ${
            editSender && "lg:max-w-full"
          }`}
        >
          {!editSender ? "Código Recebedor" : "Cadastro do Cliente"}
        </NavLink>
        <NavLink
          to={`${initialPath}/carteira/credito/${id}`}
          className={`text-[#9DA2B6] font-bold text-xl flex-grow flex-shrink text-center py-2 px-8 max-w-[420px] menu ${
            editSender && "lg:max-w-full"
          }`}
        >
          Limite de Crédito
        </NavLink>
      </div>
      {path == `${initialPath}/carteira/credito/codigo-emissor` && (
        <div className="flex  justify-center mt-8 container">
          <button className="py-4 px-6 bg-primaria text-white opacity-100 rounded-lg font-bold text-lg button-search">
            <Link to={`${initialPath}/carteira/recebedor`} className="flex gap-x-4 items-center ">
              Novo Cliente Recebedor
              <SearchAdd />
            </Link>
          </button>
        </div>
      )}
    </div>
  );
};

export default CreditInfoMenu;
